import { render, staticRenderFns } from "./SummaryLegendLabels.vue?vue&type=template&id=ea823566&scoped=true"
import script from "./SummaryLegendLabels.ts?vue&type=script&lang=ts&external"
export * from "./SummaryLegendLabels.ts?vue&type=script&lang=ts&external"
import style0 from "./SummaryLegendLabels.scss?vue&type=style&index=0&id=ea823566&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea823566",
  null
  
)

export default component.exports